export const MESSAGE_TEMPLATE_ENDPOINT_BASE = '/v2/scheduled_message_templates';
export const MESSAGE_QUERY_KEY_NAMESPACE = 'message'